import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute"; // Import the ProtectedRoute component
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Resetpassword from "./pages/Resetpassword";
import Forgotpassword from "./pages/Forgotpassword";
import MainLayout from "./components/MainLayout";
import Enquiries from "./pages/Enquiries";
import Orders from "./pages/Orders";
import Customers from "./pages/Customers";
// import Colorlist from "./pages/Colotlist";
import Categorylist from "./pages/Categorylist";
import Metallist from "./pages/Metallist";
import Productlist from "./pages/Productlist";
// import Addcolor from "./pages/Addcolor";
import Addcat from "./pages/Addcat";
import Addmetal from "./pages/Addmetal";
import Addproduct from "./pages/Addproduct";
import Couponlist from "./pages/Couponlist";
import AddCoupon from "./pages/AddCoupon";
import ViewEnq from "./pages/ViewEnq";
import CustomDesigns from "./pages/CustomDesigns";
import ViewCustomDesign from "./pages/ViewCustomDesign";
import ProductEnquiries from "./pages/ProductEnquiries";
import ViewProductEnquiry from "./pages/ViewProductEnquiry";
import ViewOrder from "./pages/ViewOrder";
import Promolist from "./pages/Promolist";
import AddPromoType from "./pages/AddPromoType";
import Puritylist from "./pages/Puritylist";
import Addpurity from "./pages/Addpurity";
import ViewProduct from "./pages/ViewProduct";
import Reviewslist from "./pages/Reviewslist";
import Bannerlist from "./pages/Bannerlist";
import Addbanner from "./pages/Addbanner";
import ViewProfile from "./pages/ViewProfile";
import GeneralSettings from "./pages/GeneralSettings";
import GoldSchemeList from "./pages/GoldSchemeList";
import AddGoldScheme from "./pages/AddGoldScheme";
import ImageFeedList from "./pages/ImageFeedList";
import AddImageFeed from "./pages/AddImageFeed";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/reset-password" element={<Resetpassword />} />
        <Route path="/forgot-password" element={<Forgotpassword />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="enquiries" element={<Enquiries />} />
          <Route path="enquiries/:id" element={<ViewEnq />} />
          <Route path="custom-designs" element={<CustomDesigns />} />
          <Route path="custom-designs/:id" element={<ViewCustomDesign />} />
          <Route path="product-enquiries" element={<ProductEnquiries />} />
          <Route path="product-enquiries/:id" element={<ViewProductEnquiry />} />
          <Route path="coupon-list" element={<Couponlist />} />
          <Route path="coupon" element={<AddCoupon />} />
          <Route path="coupon/:id" element={<AddCoupon />} />
          {/* <Route path="orders" element={<Orders />} />
          <Route path="order/:id" element={<ViewOrder />} /> */}
          <Route path="customers" element={<Customers />} />
          <Route path="reviews" element={<Reviewslist />} />
          <Route path="list-category" element={<Categorylist />} />
          <Route path="category" element={<Addcat />} />
          <Route path="category/:id" element={<Addcat />} />
          <Route path="list-promotional" element={<Promolist />} />
          <Route path="promotional" element={<AddPromoType />} />
          <Route path="promotional/:id" element={<AddPromoType />} />
          <Route path="list-metal" element={<Metallist />} />
          <Route path="metal" element={<Addmetal />} />
          <Route path="metal/:id" element={<Addmetal />} />
          <Route path="list-purity" element={<Puritylist />} />
          <Route path="purity" element={<Addpurity />} />
          <Route path="purity/:id" element={<Addpurity />} />
          <Route path="list-product/:id" element={<ViewProduct />} />
          <Route path="list-product" element={<Productlist />} />
          <Route path="product/:id" element={<Addproduct />} />
          <Route path="product" element={<Addproduct />} />
          <Route path="list-banner" element={<Bannerlist />} />
          <Route path="banner" element={<Addbanner />} />
          <Route path="banner/:id" element={<Addbanner />} />
          <Route path="profile" element={<ViewProfile />} />
          <Route path="settings" element={<GeneralSettings />} />
          <Route path="list-gold-scheme" element={<GoldSchemeList />} />
          <Route path="gold-scheme" element={<AddGoldScheme />} />
          <Route path="gold-scheme/:id" element={<AddGoldScheme />} />
          <Route path="list-image-feed" element={<ImageFeedList />} />
          <Route path="image-feed" element={<AddImageFeed />} />
          <Route path="image-feed/:id" element={<AddImageFeed />} />
        </Route>
      </Routes>
    </Router>
    // <Router>
    //   <Routes>
    //     <Route path="/" element={<Login />} />
    //     <Route path="/reset-password" element={<Resetpassword />} />
    //     <Route path="/forgot-password" element={<Forgotpassword />} />
    //     <Route path="/admin" element={<MainLayout />}>
    //       <Route index element={<Dashboard />} />
    //       <Route path="enquiries" element={<Enquiries />} />
    //       <Route path="enquiries/:id" element={<ViewEnq />} />
    //       <Route path="coupon-list" element={<Couponlist />} />
    //       <Route path="coupon" element={<AddCoupon />} />
    //       <Route path="coupon/:id" element={<AddCoupon />} />
    //       <Route path="orders" element={<Orders />} />
    //       <Route path="order/:id" element={<ViewOrder />} />
    //       <Route path="customers" element={<Customers />} />
    //       <Route path="reviews" element={<Reviewslist />} />
    //       {/* <Route path="list-color" element={<Colorlist />} />
    //       <Route path="color" element={<Addcolor />} />
    //       <Route path="color/:id" element={<Addcolor />} /> */}
    //       <Route path="list-category" element={<Categorylist />} />
    //       <Route path="category" element={<Addcat />} />
    //       <Route path="category/:id" element={<Addcat />} />
    //       <Route path="list-promotional" element={<Promolist />} />
    //       <Route path="promotional" element={<AddPromoType />} />
    //       <Route path="promotional/:id" element={<AddPromoType />} />
    //       <Route path="list-metal" element={<Metallist />} />
    //       <Route path="metal" element={<Addmetal />} />
    //       <Route path="metal/:id" element={<Addmetal />} />
    //       <Route path="list-purity" element={<Puritylist />} />
    //       <Route path="purity" element={<Addpurity />} />
    //       <Route path="purity/:id" element={<Addpurity />} />
    //       <Route path="list-product/:id" element={<ViewProduct />} />
    //       <Route path="list-product" element={<Productlist />} />
    //       <Route path="product/:id" element={<Addproduct />} />
    //       <Route path="product" element={<Addproduct />} />
    //       <Route path="list-banner" element={<Bannerlist />} />
    //       <Route path="banner" element={<Addbanner />} />
    //       <Route path="banner/:id" element={<Addbanner />} />
    //       <Route path="profile" element={<ViewProfile />} />
    //     </Route>
    //   </Routes>
    // </Router>
  );
}

export default App;
